import 'react-responsive-carousel/lib/styles/carousel.min.css';

import { ImgHTMLAttributes } from 'react';
import { Carousel as ReactResponsiveCarousel } from 'react-responsive-carousel';

import { Button } from '@any-ui-react/core';

import { ChevronLeftIcon, ChevronRightIcon } from '@anyx/shared-icons';

interface CarouselProps {
  images: ImgHTMLAttributes<HTMLImageElement>[];
}

export const Carousel = (props: CarouselProps) => {
  const { images } = props;

  return (
    <div className="carousel-wrapper">
      <ReactResponsiveCarousel
        centerMode={true}
        centerSlidePercentage={100}
        infiniteLoop={true}
        renderArrowNext={(clickHandler) => (
          <Button
            className="card mr-8 h-12 w-12 shrink-0 rounded-full p-0 [&_.mantine-Button-icon]:m-0"
            onClick={clickHandler}
            leftSection={<ChevronRightIcon />}
            size="lg"
            variant="default"
          />
        )}
        renderArrowPrev={(clickHandler) => (
          <Button
            className="card ml-8 h-12 w-12 shrink-0 rounded-full p-0 [&_.mantine-Button-icon]:m-0"
            onClick={clickHandler}
            size="lg"
            leftSection={<ChevronLeftIcon />}
            variant="default"
          />
        )}
        showIndicators={false}
        showStatus={false}
      >
        {images.map((image, key) => (
          <div key={key}>
            <img loading="lazy" alt={image.alt} {...image} />
          </div>
        ))}
      </ReactResponsiveCarousel>
    </div>
  );
};
